module.exports = __webpack_public_path__ + "static/img/nav_bgc.6a9c2fa7.png";